import { useTranslation } from "react-i18next";
import { Form, Spin } from "antd";
import { FC } from "react";
import CustomCard from "../../../../custom-card/CustomCard";
import "./university-info-detail.scss";
interface UniversityInfoDetailProps {
  universityInfoDetail: any;
  loadingDetail: boolean;
  textRendered?: string;
}

const UniversityInfoDetail: FC<UniversityInfoDetailProps> = ({
  universityInfoDetail,
  loadingDetail,
  textRendered,
}) => {
  const { t } = useTranslation();
  return (
    <section className="wrapper-settings category-management-detail" style={{height: "auto"}}>
      <div className="setting-position wrapper-inside">
        <CustomCard className="header-card" title={textRendered ? `${t("Thông tin", "Thông tin")} ${t(textRendered, textRendered)}` : t("Thông tin", "Thông tin")}>
          {loadingDetail ? (
            <div className="statistic-course-content statistic-course-loading">
              <Spin size="large" />
            </div>
          ) : (
            <section>
              <Form.Item className="setting-item" name="name" label={`${t("Tên", "Tên")} ${textRendered ? t(textRendered, textRendered) : ""}`.trim()}>
                <p className="position-content">{universityInfoDetail?.name ? (t(universityInfoDetail.name, universityInfoDetail.name) as string) : ""}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="code" label={`${t("Mã", "Mã")} ${textRendered ? t(textRendered, textRendered) : ""}`.trim()}>
                <p className="position-content">{universityInfoDetail?.code}</p>
              </Form.Item>
            </section>
          )}
        </CustomCard>
      </div>
    </section>
  );
};

export default UniversityInfoDetail;
